import React, {ReactElement, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {cx} from '@emotion/css';

import LayoutSection from '@fo/designSystem/Layout/LayoutSection/LayoutSection';
import {LayoutBackground} from '@fo/designSystem/Layout/LayoutSection/LayoutSection.types';
import {fonts} from '@fo/shared/styles/variables';
import Headers, {HeaderType} from '@fo/designSystem/Text/Headers/Headers';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';
import MarketingSignupEmailCaptureForm from '@fo/components/MarketingSignupEmailCaptureForm';

import subscribeToOurNewsletterSectionCircles from './circlesConfig';

import styles from './SubscribeToOurNewsletterSection.styles';

function SubscribeToOurNewsletterSection(): ReactElement {
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  const handleOnSubmit = (isSubmitted: boolean) => {
    setIsFormSubmitted(isSubmitted);
  };

  return (
    <LayoutSection
      circles={subscribeToOurNewsletterSectionCircles}
      type={LayoutBackground.WHITE}
      classes={{mainInner: cx(styles.container)}}
    >
      {!isFormSubmitted ? (
        <div className={cx(styles.contents)}>
          <div className={cx(styles.text)}>
            <Headers headerType={HeaderType.H2} alignment={fonts.alignment.CENTER}>
              <FormattedMessage id="subscribeToOurNewsletterSection.title" />
            </Headers>
            <Paragraph alignment={fonts.alignment.CENTER} className={cx(styles.subtitle)}>
              <FormattedMessage id="subscribeToOurNewsletterSection.subtitle" />
            </Paragraph>
          </div>
          <MarketingSignupEmailCaptureForm onSubmit={handleOnSubmit} />
        </div>
      ) : (
        <Headers alignment={fonts.alignment.CENTER} headerType={HeaderType.H2}>
          <FormattedMessage id="subscribeToOurNewsletterSection.success" />
        </Headers>
      )}
    </LayoutSection>
  );
}

export default SubscribeToOurNewsletterSection;
